import { service } from '../../../service';

const state = {
  loading: false,
  companies: []
};

const actions = {
  fetchCompanies({ commit }) {
    commit('setLoading', true);

    return service
      .get(`/admin/companies`)
      .then(result => commit('setCompanies', result.companies));
  },
  fetchCompany({ commit }, company) {
    commit('setLoading', true);

    return service.get(`/admin/companies/` + company).then(result => {
      commit('setLoading', false);
      return result;
    });
  },
  deleteCompany({ commit }, company) {
    commit('setLoading', true);

    return service
      .delete(`/admin/companies/${company}?deleteAll=true`)
      .then(result => {
        commit('setLoading', false);
        return result;
      });
  },

  clearCompany({ commit }, company) {
    commit('setLoading', true);

    return service
      .delete(`/admin/companies/${company}?deleteAll=false`)
      .then(result => {
        commit('setLoading', false);
        return result;
      });
  },

  clearLocation({ commit }, { company, location }) {
    commit('setLoading', true);

    return service
      .delete(
        `/admin/companies/${company}?deleteAll=false&location=${location}`
      )
      .then(result => {
        commit('setLoading', false);
        return result;
      });
  },

  clearItems({ commit }, { company, location, type }) {
    commit('setLoading', true);

    return service
      .delete(`/admin/companies/${company}/${location}?type=${type}`)
      .then(result => {
        commit('setLoading', false);
        return result;
      });
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCompanies(state, companies) {
    console.log(companies);
    state.companies = companies;
    state.loading = false;
  }
};

export const admin = {
  namespaced: true,
  state,
  actions,
  mutations
};
